define.alias("shared/components/shared/social-identity", "settings/components/shared/social-identity");